<template>
    <!-- Start Main Content -->
    <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Accounting Report</h2>
        </div>

    

            <div class="card">

                <div class="row" style="display: flex; gap: 1rem;">

                       <div class="mt-2">
                            <label for="tagname" class="form-label">From Date *</label>
                            <input type="date" v-model="filter.fromdate" class="form-input" id="first_input" autocomplete="off" required >
                        </div>


                          <div class="mt-2">
                            <label for="tagname" class="form-label">To Date *</label>
                            <input type="date" v-model="filter.todate" class="form-input" id="first_input" autocomplete="off" required >
                        </div>

                         <div class="mt-2">
                                            <label for="customer" class="form-label">Search Customer</label><br>
                                            <select class="form-select form-select-sm" id="customer" ref="customer" v-model="filter.custid">
                                                <option value="0" v-if="selected_customer_id==0" selected disabled>SELECT CUSTOMER</option>
                                                <option v-for="(item, index) in customerList" :key="index" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>


                       <div class="mt-6">
                            <button @click="filter_list" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm">Filter</button>
                        </div> 


                    <div class="ml-3 mt-3">
                        <label for="" class="form-label">Bill No *</label>
                        <input type="number" id="barcode" v-model="filterwise.billno"  @input="onBillNoChange" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                         <div class="ml-3 mt-3">
                        <label for="" class="form-label">Purchase No *</label>
                        <input type="number" id="barcode" v-model="filterpurwise.purno"  @input="onPurNoChange" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                        </div>

    



                    </div>

        <div class="card">
            <div class="row" style="display: flex; gap: 1rem;">
                <button @click="printTable" class="btn b-solid btn-secondary-solid cursor-pointer shadow-sm ml-2">Print</button>
                    <button @click="custModal()" class="btn b-solid btn-danger-solid cursor-pointer shadow-sm ml-2">Add Voucher</button> 
                </div>
                </div>


        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <div id="printArea">
                        <table id="datatable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Tr.Id.</th>
                                    <th class="bg-[#B2E8D9]">Entry Date</th>
                                    <th class="bg-[#B2E8D9]">Customer Name</th>
                                    <th class="bg-[#B2E8D9] text-danger">Debit</th>
                                    <th class="bg-[#B2E8D9] text-info">Credit</th>
                                    <th class="bg-[#B2E8D9]">Balance</th> 
                                    <th class="bg-[#B2E8D9]">Note</th> 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in accountList" :key="item.id">
                                    <td>{{item.id}}</td>
                                    <td>{{item.entrydate}}</td>

                                    <td><router-link :to="`/customerhistory?q=${item.cust_id}`"class="text-blue-500 hover:underline">{{item.cust_name}}</router-link></td>
                                    <td class=" text-danger">{{item.total_payable}}</td>
                                    <td class=" text-info">{{item.paid}}</td>
                                    <td class="text-success">{{ parseFloat(item.balance).toFixed(2) }}</td>
                                    <td>{{item.note}}</td> 
                                </tr> 
                            </tbody>
                            <tfoot class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr style="background:rgb(226 232 240 / 0.5)">
                                    <td colspan="3"></td>
                                    <td class="text-danger">{{Final.debit}}</td>
                                    <td class=" text-info">{{Final.credit}}</td>
                                    <!-- <td class=" text-success">{{Final.balance.toFixed(2)}}</td> -->
                                </tr>
                            </tfoot>





                        </table>
                        </div>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->



    <!-- modal -->
    <div id="custModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
            <div class="p-4 w-full max-w-lg max-h-full">
                <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                    <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                        <i class="ri-close-line text-inherit text-xl leading-none"></i>
                    </button>
                    <div class="p-4 md:p-5">

                                <div class="mt-2">
                                                <label for="customer2" class="form-label">Search Customer</label><br>
                                                <select class="form-select form-select-sm" id="customer2" v-model="voucher.custid" ref="salary1" @change="$refs.salary2.focus()"  @keydown.enter.prevent="$refs.salary2.focus()">
                                                    <option value=""></option>
                                                    <option v-for="(item, index) in customerList" :key="index" :value="item.id"  >{{ item.name }}</option>
                                                </select>
                                            </div>



                        <div class="mt-7">
                                <label for="tagname" class="form-label">Entry Date *</label>
                                <input type="date" v-model="voucher.entrydate" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary2" @keyup.enter="$refs.salary3.focus()" required >
                            </div>
                    
                            <div class="mt-7">
                                <label for="tagname" class="form-label">Paid *</label>
                                <input type="number" v-model="voucher.paid" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary3" @keyup.enter="$refs.salary5.focus()" required >
                            </div>

                            <div class="mt-7">
                                <label for="tagname" class="form-label">Note *</label>
                                <input type="text" v-model="voucher.note" class="form-input" id="first_input" placeholder="Type Here" autocomplete="off" ref="salary5" @keyup.enter="$refs.savebtn.focus()" required >
                            </div>

                            <div class="flex justify-end mt-7">
                                <button @click="save_salary" class="btn b-solid btn-primary-solid cursor-pointer shadow-sm" ref="savebtn">Save</button>
                            </div> 
                    </div>
                </div>
            </div>
        </div>
    <!-- modal -->







</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
name: 'DeliveryReport',
components: {
 
} ,
mounted(){

    if (this.$route.query.q) {
           this.selected_customer_id=this.$route.query.q;
           this.getBasics(this.$route.query.q);
    }else{
       this.getBasics();
    }
},
data() {
 return {
    selected_customer_id:'',
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     accountList:[],
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
     filter:{
        fromdate:this.todayDate(),
        todate:this.todayDate(),
        custid:''
     },
     customerList:[],

       Final:{debit:0,credit:0,balance:0},

     filterwise:{
        billno:''
     },
     filterpurwise:{
        purno:''
     },

       voucher:{
                entrydate:this.todayDate(),
                paid:'',
                note:'',
                custid:''
            },



 }
 }, 
methods:{
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
                $("#custModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics(id) {
       var self=this;
         axios.post('getAccounting',{id:id}).then(function (response) {
            self.destroyTable();
                 self.accountList=response.data.accountList;
                 self.employees=response.data.userDetails;
                 self.customerList=response.data.customerList;

                      if(self.selected_customer_id>0){
                        self.customerList= self.customerList.filter(customer => 
                                customer.id==self.selected_customer_id
                                );
                    }


                }).then(()=>{ 
                   var self=this;





            $("#customer").select2({
                        width: '250px', 
                        placeholder:"Search Customer Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
                     //  alert(event.target.value);
                             self.filter.custid=event.target.value; 
                                 
                            
                        });
                                     if (this.$route.query.q) {
                                            $('#customer').val(this.$route.query.q).trigger('change');
                                        }




            $("#customer2").select2({
                        width: '450px', 
                        placeholder:"Search Customer Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
                     //  alert(event.target.value);
                             self.voucher.custid=event.target.value; 
                                 
                            
                        });
                                






                                        


           self.refreshTable();
           self.calculateTotal();




              
                    });;
  }, 
 async filterCustomer(custid) {
       var self=this;
         axios.post('getCustomerSales',{custid:custid}).then(function (response) {
                  self.destroyTable();

                 self.accountList=response.data.accountList;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
                    self.refreshTable();

                    self.calculateTotal();


                   // $(".datatable").DataTable().destroy();

                    // self.datatable= $(".datatable").DataTable({
                    //         "paging": true,
                    //         "ordering": true,  
                    //         "autoWidth": false });

              
                    });;
  }, 
            




     todayDate() {
                var today = new Date();
                var month = today.getMonth() + 1;

                return today.getFullYear() + '-' + ((month < 10) ? '0' + month : month) + '-' + ((today.getDate() < 10) ? '0' + today.getDate() : today.getDate());//today.getDate();;

            },






async filter_list() {
       var self=this;
         axios.post('getfilterAccounting',self.filter).then(function (response) {
              self.destroyTable();


                 self.accountList=response.data.accountList;
                 self.employees=response.data.userDetails;
                 self.customerList=response.data.customerList;


                }).then(()=>{ 


                   self.refreshTable();
                    self.calculateTotal();

              
                    });;
  }, 



destroyTable(){
    if ($.fn.dataTable.isDataTable('.datatable')) {
                        $('.datatable').DataTable().destroy();
                    }
},
      refreshTable(){
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false,
                            "order": [] 
                            });
              
                 
},

            calculateTotal(){
            var self=this;
            self.Final=  {debit:0,credit:0,balance:0};


                Array.from(self.accountList).forEach((row) => {
                self.Final.debit+=parseFloat(row.total_payable);
                self.Final.credit+=parseFloat(row.paid);
                self.Final.balance+=parseFloat(row.balance);


                });
            },




delete_category() {
                var self = this; 
                axios.post('deleteProduct', {deleteId:this.deleteId})
                    .then(response => {
                        self.accountList=response.data.products;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },


printTable() {
    window.print();
},


   onBillNoChange() {

var self=this;
         axios.post('getFilterWiseAccounting',self.filterwise).then(function (response) {
            self.destroyTable();
                 self.accountList=response.data.accountList;
                 self.employees=response.data.userDetails;
                 self.customerList=response.data.customerList;
                }).then(()=>{ 
         
           self.refreshTable();
    
          self.calculateTotal();



              
                    });;
 
    },


      onPurNoChange() {

var self=this;
         axios.post('getFilterpurWiseAccounting',self.filterpurwise).then(function (response) {
            self.destroyTable();
                 self.accountList=response.data.accountList;
                 self.employees=response.data.userDetails;
                 self.customerList=response.data.customerList;
                }).then(()=>{ 
         
           self.refreshTable();
    
          self.calculateTotal();



              
                    });;
 
    },


        
    custModal(){

        $("#custModal").removeClass('hidden');
        
        },

  save_salary() {
                    var self = this;

                    if(self.voucher.custid==''){
                    self.$swal("Select Customer Required");
                    }
                    else if(self.voucher.entrydate==''){
                        self.$swal("Entry Date Required");
                    }else if(self.voucher.paid === '' ){
                         self.$swal(" Paid  Required");                          
                    }   
                    else {
                    axios.post('save_cust_accounting', this.voucher)
                        .then(response => {
                                 self.destroyTable();
                            var msg = response.data.msg;
                            var isSuccess = response.data.status;
                            self.accountList=response.data.accountList;
                            self.employees=response.data.userDetails;
                            self.customerList=response.data.customerList;
                
                        self.salary={entrydate:'',paid:'',note:'',},

                            self.$swal(msg);
                            if (isSuccess == 1) {
                                self.closeModal();
                            }
                        }).then(()=>{ 
                        self.refreshTable();
                          })    
                        .catch(error => {
                            console.log('Error on Authentication: ' + error);
                        });

                    }
                },







}
}
</script>
<style scoped>
@media print {
    body * {
        visibility: hidden;
    }
    #printArea, #printArea * {
        visibility: visible;
    }
    #printArea {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
    }
}
</style>